// extracted by mini-css-extract-plugin
export default {"HonorariosContainer":"Honorarios_HonorariosContainer__Oxet7","accordion":"Honorarios_accordion__kT0F3","header":"Honorarios_header__oCxYm"};